<p class="heading">Lieferdatum</p>
<mat-list>
  <mat-list-item>
    <span matListItemTitle>Wunschlieferdatum:</span>
    @if (deliveryDate()) {
      <span matListItemLine>{{ deliveryDate() | luxonDate }}</span>
    } @else {
      <span matListItemLine>schnellstmöglich</span>
    }
  </mat-list-item>
</mat-list>
